<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>

    <div class="page-title-toolbar">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="formations-tabs" [mat-stretch-tabs]="false">
        @for (link of nav_links; track link.link) {
          <a mat-tab-link [routerLink]="link.link" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
            {{ link.label }}
          </a>
        }
      </nav>
    </div>
  </div>

  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  <router-outlet />
</div>
